import {
  PushImageType,
  PushImagesDetails,
  pushImages,
} from '@/store/templates/types';

export function pushImagePreviewUrl(
  details: PushImagesDetails | undefined,
  type: PushImageType,
): string {
  const image = findPushImage(details, type);
  if (!image) {
    return '';
  }
  return image.externalUrl || image.internalUrl || '';
}

export function findPushImage(
  details: PushImagesDetails | undefined,
  type: PushImageType,
): pushImages | undefined {
  return details?.pushImages?.find((img) => img.type === type);
}

export function ensurePushImage(details: PushImagesDetails, type: PushImageType): pushImages {
  if (!details.pushImages) {
    details.pushImages = [];
  }
  let image = findPushImage(details, type);
  if (!image) {
    image = { type };
    details.pushImages.push(image);
  }
  return image;
}

export function getUploadFileId(image?: pushImages): string | number | undefined {
  return image?.uploadFilesId ?? (image as { upload_files_id?: string | number })?.upload_files_id;
}
